import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";

import Login from "./pages/auth/login";
import Uploadfile from "./pages/dashboard/uploadfile";
import PubChatUpload from "./pages/dashboard/PubChatUpload";
import Layouts from "./components/layouts/layout";
import PublicationView from "./components/layouts/publicationview";
import GenerationsHistory from "./pages/dashboard/GenerationsHistory";
import Dashboard from "./pages/dashboard/Dashboard";
import AccountSettings from "./pages/settings/AccountSettings";
import HelpSection from "./components/layouts/helpSection";
import SupportTickets from "./pages/support/SupportTickets";
import PubChat from "./components/layouts/pubChat";  
import PubVerse from "./pages/pubverse/pubVerse";
import PubLibrary from "./pages/publibrary/pubLibrary";
import AdminPanel from "./pages/admin/AdminPanel";
import { NotificationProvider } from "./contexts/NotificationContext";
import  {WebSocketProvider}  from "./contexts/WebSocketContext";
import FloatingChatBot from "./components/common/FloatingChatBot";

// Layout wrapper that includes FloatingChatBot
const AppLayout = () => {
  return (
    <>
      <Outlet />
      <FloatingChatBot />
    </>
  );
};

// Protected Route Component
const ProtectedRoute = () => {
  const token = localStorage.getItem("authToken");
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: "/uploadfile",
            element: <Uploadfile />,
          },
          {
            path: "/pubchat-upload",
            element: <PubChatUpload />,
          },
          {
            path: "/layout",
            element: <Layouts />,
          },
          {
            path: "/publicationview/:id",
            element: <PublicationView />,
          },
          {
            path: "/pubChat/:id", 
            element: <PubChat />,   
          },
          {
            path: "/GenerationsHistory",
            element: <GenerationsHistory />,
          },
          {
            path: "/Dashboard",
            element: <Dashboard />,
          },
          {
            path: "/AccountSettings",
            element: <AccountSettings />,
          },
          {
            path: "/helpSection",
            element: <HelpSection />,
          },
          {
            path: "/pubVerse",
            element: <PubVerse />,
          },
          {
            path: "/pubLibrary",
            element: <PubLibrary />,
          },
          {
            path: "/support-tickets",
            element: <SupportTickets />,
          },
          {
            path: "/admin-panel",
            element: <AdminPanel />,
          }
        ]
      }
    ]
  }
]);

// function App() {
//   return <RouterProvider router={router} />
// }

function App() {
  return (
     
    <NotificationProvider>
      <WebSocketProvider>
        <RouterProvider router={router} />
      </WebSocketProvider>
    </NotificationProvider>
  );
}

export default App;
